import { RootReduxStateShape } from '_types/Redux';
import { useDispatch, useSelector } from 'react-redux';
import {
    setFullScreenMode,
    setShowBottomNav,
    setShowBottomNavForcefully,
    setShowOverviewTip,
    setShowPremiumAdOnHome,
    setShowSocialHeader,
} from '../LayoutSlice';

type Return = {
    canShowBottomNavigation: boolean;
    canShowBottomNavForcefully: boolean;
    canShowSocialHeader: boolean;
    canShowOverviewTip: boolean;
    canShowPremiumAdOnHome: boolean;
    setCanShowSocialHeader: (flag: boolean) => void;
    setCanShowBottomNav: (flag: boolean) => void;
    setCanShowBottomNavForcefully: (flag: boolean) => void;
    setIsFullScreenMode: (flag: boolean) => void;
    displayOverviewTip: (isOverviewTipVisible: boolean) => void;
    displayPremiumAdOnHome: (isPremiumAdOnHomeVisible: boolean) => void;
};

const useLayoutToggler = (): Return => {
    const {
        canShowBottomNavigation,
        canShowSocialHeader,
        canShowOverviewTip,
        canShowBottomNavForcefully,
        canShowPremiumAdOnHome,
    } = useSelector((state: RootReduxStateShape) => state.layout);

    const dispatch = useDispatch();

    const setCanShowSocialHeader = (flag: boolean): void => {
        dispatch(setShowSocialHeader(flag));
    };

    const setCanShowBottomNav = (flag: boolean): void => {
        dispatch(setShowBottomNav(flag));
    };

    const setCanShowBottomNavForcefully = (flag: boolean): void => {
        dispatch(setShowBottomNavForcefully(flag));
    };

    const setIsFullScreenMode = (on: boolean): void => {
        dispatch(setFullScreenMode(on));
    };

    const displayOverviewTip = (isOverviewTipVisible: boolean): void => {
        dispatch(setShowOverviewTip(isOverviewTipVisible));
    };

    const displayPremiumAdOnHome = (
        isPremiumAdOnHomeVisible: boolean,
    ): void => {
        dispatch(setShowPremiumAdOnHome(isPremiumAdOnHomeVisible));
    };

    return {
        canShowBottomNavigation,
        canShowBottomNavForcefully,
        canShowSocialHeader,
        canShowOverviewTip,
        canShowPremiumAdOnHome,
        setCanShowSocialHeader,
        setCanShowBottomNav,
        setCanShowBottomNavForcefully,
        setIsFullScreenMode,
        displayOverviewTip,
        displayPremiumAdOnHome,
    };
};

export default useLayoutToggler;
